export class DataConsts {
    static readonly CHARGEMENT = "Chargement";
    static readonly VALIDER = "Validé";
    static readonly ENATTENTE = "En attente";
    static readonly FAVORABILITY = "Favorable"
}